

<div *ngIf="isLoading" class="loading">
    <div class='uil-ring-css' style='transform:scale(0.79);'>
      <div></div>
    </div>
</div>

<div class="container" fxLayoutGap="10px" fxLayout="column">
    
    <mat-card  fxFlexLayout="row" fxLayoutGap="10px" fxLayoutAlign="center center" >
        

        <mat-form-field     appearance="outline" >
            <mat-label>Du</mat-label>
            <input matInput [matDatepicker]="date_Debut" placeholder="Du" [(ngModel)]="dateDeb">
            <mat-datepicker-toggle matSuffix [for]="date_Debut"></mat-datepicker-toggle>
            <mat-datepicker #date_Debut></mat-datepicker>
        </mat-form-field>
        <mat-form-field     appearance="outline" >
            <mat-label>Au</mat-label>
            <input matInput [matDatepicker]="date_Fin" placeholder="Au" [(ngModel)]="dateFin">
            <mat-datepicker-toggle matSuffix [for]="date_Fin"></mat-datepicker-toggle>
            <mat-datepicker #date_Fin></mat-datepicker>
        </mat-form-field>
    
    
        <button [disabled]="!dateDeb || !dateFin" fxFlex="10" mat-raised-button color="primary" (click)="refreshData()">Rechercher</button>
        <!-- <button [disabled]="!dataLoaded" fxFlex="10" mat-raised-button color="success" (click)="exporter.exportTable('Excel',{ 'fileName' : 'Uniges_SOF_Details___' + dateDeb + '___' + dateFin})" >Exporter Excel</button>
        <button [disabled]="!dataLoaded " mat-raised-button color="success" (click)="exporter.exportTable('csv',{ 'fileName' : 'Uniges_SOF_Details___' + dateDeb + '___' + dateFin })" >Exporter CSV</button> -->
    </mat-card>

 
    <app-table  #tableSummary [source]="SummarySource" ></app-table>

 
</div>
